import EmptyData from 'components/common/EmptyData';
import DAYS from 'constants/days';
import { capitalize } from 'lodash';
import moment from 'moment';
import React, { ReactElement, useMemo } from 'react';
import { IAppointment } from 'types/appointments';
import { groupDataByElementProps } from 'utils';

const DefaultAppointmentListDesign: React.FC<{
  children: (appointment: IAppointment) => ReactElement<any>;
  appointments?: IAppointment[];
}> = ({ children, appointments }) => {
  const groupAppointments = useMemo(
    () =>
      groupDataByElementProps<IAppointment>(
        [{ date: (d) => moment(d).format('YYYY').toString() }, { date: (d) => moment(d).format('DD/MM').toString() }],
        appointments,
      ),
    [appointments],
  );

  const generateAppointmentsByDate = (appointmentArrayByDate: IAppointment[]) => {
    const appointmentDateTime = moment(appointmentArrayByDate[0].date);
    const [appointmentMonth, appointmentDate] = appointmentDateTime
      .format('MMMM Do')
      .replace(/(\d)(st|nd|rd|th)/g, '$1<sup>$2</sup>')
      .split(' ');
    const appointmentDayInWeek = appointmentDateTime.day();
    // const appointmentYear = appointmentDateTime.year();
    return (
      <div key={appointmentDateTime.toString()} className='common-appointments-by-day-container'>
        <div className='day-date'>
          <div className='day'>{capitalize(DAYS[appointmentDayInWeek])}</div>
          <div className='date' dangerouslySetInnerHTML={{ __html: `${appointmentDate}` }} />
          <div className='day'>{appointmentMonth}</div>
        </div>
        <div className='gx-flex-column gx-flex-1 common-appointments-by-day-list'>
          {appointmentArrayByDate.map((app) => children(app))}
        </div>
      </div>
    );
  };

  const generateAppointmentsByYear = (appointmentArrayByYear: IAppointment[][]) => {
    const appointmentYear = moment(appointmentArrayByYear[0][0].date).format('YYYY').toString();
    return (
      <div className='common-appointment time' key={appointmentYear}>
        <div className='year'>{appointmentYear}</div>
        <div>{appointmentArrayByYear.map(generateAppointmentsByDate)}</div>
      </div>
    );
  };
  return (
    <div className='common-appointments-container'>
      {groupAppointments?.length ? groupAppointments.map(generateAppointmentsByYear) : <EmptyData />}
    </div>
  );
};

export default React.memo(DefaultAppointmentListDesign);
